import Lottie from 'lottie-react';
import styles from './Loading.module.scss';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import animation from './CookingLoader.json';

const LoadingForkSpoon = () => (
  <Lottie
    animationData={animation}
    loop
    autoplay
    className={styles.loading_fork_spoon}
  />
);

export default LoadingForkSpoon;
